var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button, IconSvg } from '@utex/ui-kit';
import { avatar, Text, GravatarItem, iconWarning } from './styles';
import { useQuery, gql } from '@apollo/client';
import { getUserInitials } from './getUserInitials';
import { MenuButton } from '../../../../components/MenuButton';
import { getTransparentButtonColor } from '../../../HeaderButtons/buttonsView';
import { IconWarning } from '../../../Icons';
var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query {\n    currentUser {\n      id\n      userInfo {\n        email\n        login\n        avatarUrl\n        firstName\n        lastName\n      }\n    }\n  }\n"], ["\n  query {\n    currentUser {\n      id\n      userInfo {\n        email\n        login\n        avatarUrl\n        firstName\n        lastName\n      }\n    }\n  }\n"])));
export function UserAvatar(props) {
    var accountLocked = props.accountLocked, openSideMenu = props.openSideMenu, menuView = props.menuView, warning = props.warning, other = __rest(props, ["accountLocked", "openSideMenu", "menuView", "warning"]);
    var _a = useQuery(query), loading = _a.loading, error = _a.error, data = _a.data;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.currentUser)) {
        return React.createElement(MenuButton, { openSideMenu: openSideMenu, view: menuView });
    }
    var email = data.currentUser.userInfo.email;
    var initials = getUserInitials(data.currentUser.userInfo);
    return (React.createElement(Button, __assign({ view: getTransparentButtonColor(menuView), onClick: function (e) {
            e.stopPropagation();
            openSideMenu && openSideMenu();
        }, css: avatar(menuView, email) }, other),
        warning && React.createElement(IconWarning, { css: iconWarning }),
        email && (React.createElement(GravatarItem, { email: email, default: 'blank', size: 100, "data-testid": "user-avatar" })),
        email && initials && React.createElement(Text, { "data-testid": "userInitials" }, initials),
        accountLocked && React.createElement(IconSvg, { src: "locker", width: 11, height: 12 })));
}
var templateObject_1;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/components/UserAvatar/index.js
// module id = 1370
// module chunks = 118